import React from 'react'

function StatCard(props) {
    const { className, title, value } = props;

    return (
        <div className={`dashboardView-card ${className}`}>
            <p className="dashboardView-card-title">{title}</p>
            <p className="dashboardView-card-value">{value}</p>
        </div>
    )
}

export default StatCard